@if (!isCustomCut()) {
  <ideal-cart-item-quantity-selector [itemId]="itemId()" sellMultipleHints="false" *renderInItemResult="LayoutTargets.Actions" />
} @else {
  <ideal-wire-cut-custom-length-selector
    *renderInItemResult="LayoutTargets.Actions"
    [itemId]="itemId()"
  ></ideal-wire-cut-custom-length-selector>
}
